module.exports = __webpack_public_path__ + "img/正在建设中.e7d072e1.png";